<div class="promotion-methods-container">
  <h2 class="promotion-method-titile">{{ 'view_translations.promotion_methods' | translate }}</h2>
  <p class="promotion-form-instruction">{{ 'view_translations.ivr_promotion_form_instruction' | translate }}</p>
  <form [formGroup]="promotionMethodForm!">
    <div
      class="method-description-container input-container global-transition"
      [ngClass]="{
        'invalid-input': formControls?.promotionMethodDescriptionInput?.touched && formControls?.promotionMethodDescriptionInput?.invalid && isFormSubmitted,
        'focused-input-default': activeElement === activeElementsList[0]
      }">
      <label class="form-label global-transition"
        >{{ 'view_translations.description' | translate }}
        <textarea
          (focus)="activeElement = activeElementsList[0]"
          (blur)="activeElement = ''"
          class="global-transition"
          formControlName="promotionMethodDescriptionInput"
          placeholder="{{ 'view_translations.type_text' | translate }}"
          (input)="updateValue('description', 'promotionMethodDescriptionInput')">
        </textarea>
      </label>
    </div>
    <div
      class="error-text"
      *ngIf="isFormSubmitted && formControls?.promotionMethodDescriptionInput?.invalid && (formControls?.promotionMethodDescriptionInput?.dirty || formControls?.promotionMethodDescriptionInput?.touched)">
      <small *ngIf="formControls?.promotionMethodDescriptionInput?.errors?.required" class="form-text text-danger"
        >{{ 'view_translations.this_field_is_required' | translate }}</small
      >
    </div>

    <div
      class="promotion-url-container input-container global-transition"
      [ngClass]="{
        'invalid-input': formControls?.promotionURLInput?.touched && formControls?.promotionURLInput?.invalid && isFormSubmitted,
        'focused-input-default': activeElement === activeElementsList[1]
      }">
      <label class="form-label global-transition"
        >{{ 'view_translations.page_address' | translate }}
        <input
          (focus)="activeElement = activeElementsList[1]"
          (blur)="activeElement = ''"
          formControlName="promotionURLInput"
          type="text"
          class="global-transition"
          placeholder="{{ 'view_translations.enter_url_address' | translate }}"
          (input)="updateValue('website', 'promotionURLInput')" />
      </label>
      <span class="error-icon" *ngIf="formControls?.promotionURLInput?.touched && formControls?.promotionURLInput?.invalid && isFormSubmitted">
        <nb-icon icon="cross-circle" pack="icomoon"></nb-icon>
      </span>
    </div>
    <div
      class="error-text"
      *ngIf="isFormSubmitted && formControls?.promotionURLInput?.invalid && (formControls?.promotionURLInput?.dirty || formControls?.promotionURLInput?.touched)">
      <small *ngIf="formControls?.promotionURLInput?.errors?.urlInvalid" class="form-text text-danger"
        >{{ 'view_translations.incorrect_url_address' | translate }}</small
      >
    </div>
  </form>
</div>
